import Checkbox from '@material-ui/core/Checkbox'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import moment from 'moment/moment'
import React from 'react'
import { Link } from 'react-router-dom'
import { useCheckedContext } from '../../context/CheckedContext'
import { TableHeadCell } from './MsgsTable'
import { useTableStyles } from './styles'

interface TableBodyProps {
  heads: TableHeadCell[],
  data: Array<any>,
  cellDate?: string,
  cellAttach?: string,
  cellState?: string,
  withChecked?: boolean
}

export const TableBodyRender = ({
  heads,
  data,
  cellDate = 'deliveredAt',
  cellAttach = 'attachment',
  cellState = 'state',
  withChecked
}: TableBodyProps) => {
  const classes = useTableStyles()

  const { checked, toggleChecked } = useCheckedContext()

  return (
    <TableBody>
      {data.map((row, index) =>
        <TableRow
          hover
          tabIndex={-1}
          key={index}
          style={row.isRead ? undefined : ({ fontWeight: 'bold' })}
        >
          {withChecked &&
            <TableCell className={classes.cellChecked}>
              <Checkbox
                size="small"
                color="primary"
                checked={checked.includes(row.id)}
                onChange={() => toggleChecked(row.id)}
              />
            </TableCell>
          }
          {heads.map((item, index) => {
              let pureValue: any = row[item.id]
              if (item.id === cellDate) {
                pureValue = moment(pureValue).format('DD.MM.YYYY HH:mm')
              }
              if (item.id === cellAttach) {
                pureValue = pureValue ? <AttachFileIcon fontSize="small"/> : ''
              }
              if (item.id === cellState) {
                pureValue = pureValue ? <span title={pureValue}><InfoOutlinedIcon fontSize="small"/></span> : ''
              }

              if (row['link_' + item.id]) {
                pureValue = <Link to={row['link_' + item.id]}>{pureValue}</Link>
              }

              const cellClass = [
                [cellAttach, cellState].includes(item.id) ? classes.cellAttach : '',
                !row.isRead ? classes.cellUnread : '',
                item.id === cellDate ? classes.cellDate : ''
              ]
              return (
                <TableCell style={{ fontWeight: 'inherit' }}
                           className={cellClass.join(' ')}
                           key={index}>{pureValue}</TableCell>
              )
            }
          )}
        </TableRow>
      )}
    </TableBody>
  )
}
